import React from "react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/app/SEO";

export default function CookiesPage() {
  const openPrefs = () => {
    try { window.dispatchEvent(new CustomEvent("re:open-cookie-preferences")); }
    catch (e) { /* older browsers fallback */ }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 space-y-8">
      <SEO title="Politique de cookies" description="Comment Résiliation Express utilise les cookies et comment gérer vos préférences." canonical="/cookies" />
      <header>
        <h1 className="text-4xl font-bold tracking-tight mb-2">Politique de cookies</h1>
        <p className="text-sm text-muted-foreground">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}</p>
      </header>

      <section>
        <h2 className="text-xl font-semibold mb-3">Qu'est-ce qu'un cookie ?</h2>
        <p className="text-sm leading-relaxed">Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, mobile) par un site que vous visitez. Il permet de reconnaître votre navigateur et de mémoriser certaines informations.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Catégories de cookies utilisées</h2>
        <div className="space-y-4 text-sm">
          <div className="rounded-md border border-border p-4">
            <div className="font-semibold mb-1">Cookies nécessaires (toujours actifs)</div>
            <p className="text-muted-foreground">Session utilisateur, sécurité, préférences d'affichage (thème), mémorisation du choix de consentement. Sans ces cookies, le site ne peut pas fonctionner correctement.</p>
          </div>
          <div className="rounded-md border border-border p-4">
            <div className="font-semibold mb-1">Cookies de mesure d'audience</div>
            <p className="text-muted-foreground">Google Analytics 4 (identifiant G-Q7YLTN0K4J). Ces cookies mesurent la fréquentation du site de manière agrégée. Aucune donnée personnelle (email, téléphone, adresse) n'est transmise. Actifs uniquement avec votre consentement.</p>
          </div>
          <div className="rounded-md border border-border p-4">
            <div className="font-semibold mb-1">Cookies de fonctionnalité</div>
            <p className="text-muted-foreground">Améliorent votre expérience (ex : mémorisation de la dernière recherche). Actifs uniquement avec votre consentement.</p>
          </div>
          <div className="rounded-md border border-border p-4">
            <div className="font-semibold mb-1">Cookies marketing</div>
            <p className="text-muted-foreground">Google Tag Manager (conteneur GTM-59FL4GPL). Utilisés pour mesurer la performance de nos campagnes publicitaires si nous en menons. Actifs uniquement avec votre consentement.</p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Consent Mode v2</h2>
        <p className="text-sm leading-relaxed">Nous implémentons Google Consent Mode v2. Tant que vous n'avez pas donné votre consentement, aucun cookie non essentiel n'est déposé et aucun signal ne peut être utilisé pour personnaliser des publicités.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Gérer mes préférences</h2>
        <p className="text-sm leading-relaxed mb-3">Vous pouvez modifier votre choix à tout moment. Le refus est aussi simple que l'acceptation.</p>
        <Button onClick={openPrefs} className="bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="open-cookie-prefs-btn">
          Gérer mes cookies
        </Button>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Preuve du consentement</h2>
        <p className="text-sm leading-relaxed">Nous conservons la version de la politique acceptée, la date, votre choix par catégorie et la méthode de collecte. Aucune adresse IP complète n'est stockée à ces seules fins.</p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Durée</h2>
        <p className="text-sm leading-relaxed">Les cookies analytiques et marketing sont conservés au maximum 13 mois. Passé ce délai, votre choix vous est à nouveau demandé.</p>
      </section>
    </div>
  );
}
